import { errorResponseHandler, responseHandler } from "../Utils/handler.ts";
import { api } from "./config/axiosConfig.js";
import { defineCancelApiObject } from "./config/axiosUtils.js";
import { store } from "../redux/Store.ts";

export const AuthAPI = {
  // Claude: forceLogin flag kicks existing active session 18-04-2026
  postLogin: async (login, cancel = false) => {
    const response = await api.request({
      url: "/auth/login/",
      method: "POST",
      data: login,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });

    if (response.data?.code == 200) {
      response.data.success = true;
    }

    return response.data;
  },

  postForgetPassword: async (data, cancel = false) => {
    const response = await api.request({
      url: "/auth/forgot-password",
      method: "POST",
      data: data,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });

    return response.data;
  },

  createPassword: async (id, data, cancel = false) => {
    const response = await api.request({
      url: "/auth/reset-password/" + id,
      method: "POST",
      data: data,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });

    return response.data;
  },

  patchRefreshToken: async (token, cancel = false) => {
    try {
      const response = await api.request({
        url: "/auth/refresh-token",
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });

      return responseHandler(response);
    } catch (err) {
      return errorResponseHandler(err);
    }
  },

  // Claude: N25 — self-registration 05-03-2026
  postNewUserRegistration: async (data, cancel = false) => {
    const response = await api.request({
      url: "/auth/new-user-registration",
      method: "POST",
      data: data,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return response.data;
  },

  // Claude: sign-up flow — step-by-step gate checks + OTP 19-03-2026
  // Note: response.data.data unwraps the ResponseInterceptor { data: <payload> } envelope
  checkEmailForSignup: async (email, role) => {
    const response = await api.request({
      url: "/auth/check-email",
      method: "POST",
      data: { email, role },
    });
    return response.data.data;
  },

  checkCompanyUrlForSignup: async (email, companyUrl) => {
    const response = await api.request({
      url: "/auth/check-company-url",
      method: "POST",
      data: { email, companyUrl },
    });
    return response.data.data;
  },

  checkCompanyNameForSignup: async (email, companyUrl, companyName) => {
    const response = await api.request({
      url: "/auth/check-company-name",
      method: "POST",
      data: { email, companyUrl, companyName },
    });
    return response.data.data;
  },

  // Claude: recaptchaToken added — verified server-side before OTP is sent 24-03-2026
  sendEmailOTP: async (email, role, recaptchaToken) => {
    const response = await api.request({
      url: "/auth/send-email-otp",
      method: "POST",
      data: { email, role, recaptchaToken },
    });
    return response.data.data;
  },

  verifyEmailOTP: async (email, role, otp) => {
    const response = await api.request({
      url: "/auth/verify-email-otp",
      method: "POST",
      data: { email, role, otp },
    });
    return response.data.data;
  },

  postUpdatePassword: async (data, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/auth/password/update",
      method: "POST",
      data: data,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });

    return response.data;
  },
};

const cancelApiObject = defineCancelApiObject(AuthAPI);
